import React, { useState, useRef, useEffect, useContext } from 'react'
import { StyleSheet, Image } from 'react-native';
import TransTextNextLine from '../../../../common/language/TransTextNextLine';
import { useTranslation } from 'react-i18next';

import { hpContext } from '../../../HPContext';
import HpTopHeadImg from './img/HpTopHeadImg';


function HpTopHead() {
  const { t } = useTranslation();
  const isWide = useContext(hpContext).isWide;
  const iosLink = useContext(hpContext).iosLink;
  const androidLink = useContext(hpContext).androidLink;

  const onClickIosDownload = useContext(hpContext).onClickIosDownload;
  const onClickAndroidDownload = useContext(hpContext).onClickAndroidDownload;

  // 動画（自前ホスティング。旧YouTube埋め込みはプレイヤーJS・テレメトリ通信が重くLCP/CLS悪化の原因だったため2026-09-13に切替）
  const videoRef = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);


  // 動画の読み込み確認:それまで画像表示
  const handleVideoReady = () => {
    setTimeout(() => {
      setIsVideoLoaded(true);
    }, 500);
  }


  // ブラウザを閉じて開くと再生が止まったままになることがあるため、一時停止を検出したら再生を再開する
  const onPause = () => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }


  // autoPlay属性だと初期描画と同時にデコードが始まりTBT悪化の原因になるため、
  // 初期描画が落ち着いてからJSで再生開始する（メインスレッドの空き時間を使う）
  useEffect(() => {
    const startPlayback = () => {
      if (videoRef.current) {
        videoRef.current.play().catch(() => {});
      }
    };

    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(startPlayback, { timeout: 2000 });
      return () => window.cancelIdleCallback(id);
    } else {
      const id = setTimeout(startPlayback, 200);
      return () => clearTimeout(id);
    }
  }, []);


  return (
    <header id="header">

      <div className='mainWrap'>

        <div className='contentWrap'>
          {/* 説明 */}
          <div className='titleWrap'>
            <div className='headWrap'>
              <div className='mainHead'>
                <img
                  className='logoImg'
                  src='./assets/img/logo.png'
                  alt='Skaters'
                />
                <h1 className='mainTitle'>Skaters</h1>
              </div>

              {/*
                トリックの瞬間を見逃さない<br/>
                スケーター専用アプリ<br/>
              */}
              <p className='subTitle'>
                <TransTextNextLine text={t('common.catch')} />
              </p>
            </div>
          </div>

          {/* 画像 */}
          <HpTopHeadImg />
        </div>

        {/* ダウンロード */}
        <div className='downloadWrap'>
          <a className='downloadLink' href={iosLink} onClick={onClickIosDownload} rel="noopener" target="_blank">
            <img
              className='download-btn download-btn-apple'
              src={t('download.iosBtnPath')}
              width={t('download.iosBtnWidth')}
              height={t('download.iosBtnHeight')}
              alt='apple-store'
            />
          </a>

          <a className='downloadLink' href={androidLink} onClick={onClickAndroidDownload} rel="noopener" target="_blank">
            <img
              className='download-btn download-btn-google'
              src={t('download.androidBtnPath')}
              width={t('download.androidBtnWidth')}
              height={t('download.androidBtnHeight')}
              alt='google-store'
            />
          </a>
        </div>

      </div>

      {/* 動画 */}
      <div id='video-area-over'></div>
      <div id="video-area">
        {!isVideoLoaded && (
          <Image
            defaultSource={'./assets/img/park/park2_web.jpg'}
            resizeMode='cover'
            style={{height: '100%'}}
          />
        )}
        <video
          ref={videoRef}
          className='video'
          src='/assets/movie/park_bg.mp4'
          poster='/assets/img/park/park2_web.jpg'
          muted
          loop
          playsInline
          onCanPlay={handleVideoReady}
          onPause={onPause}
        />
      </div>
    </header>
  );
}


const styles = StyleSheet.create({
});

export default HpTopHead;
